import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { galleryCategories, galleryItems } from '../data/siteData'
import { bgPhoto } from '../utils/img'
import ScrollReveal from './ScrollReveal'
import './GalleryGrid.css'

export default function GalleryGrid() {
  const [searchParams, setSearchParams] = useSearchParams()
  const categoryFromUrl = searchParams.get('category')
  const initialCategory =
    categoryFromUrl && galleryCategories.includes(categoryFromUrl) ? categoryFromUrl : 'All'

  const [active, setActive] = useState(initialCategory)
  const [lightbox, setLightbox] = useState(null)

  const handleSelect = (cat) => {
    setActive(cat)
    if (cat === 'All') {
      searchParams.delete('category')
    } else {
      searchParams.set('category', cat)
    }
    setSearchParams(searchParams, { replace: true })
  }

  const filtered =
    active === 'All' ? galleryItems : galleryItems.filter((g) => g.category === active)

  return (
    <div className="gallery-wrap">
      <div className="gallery-filters" role="tablist" aria-label="Filter gallery by category">
        {galleryCategories.map((cat) => (
          <button
            key={cat}
            role="tab"
            aria-selected={active === cat}
            className={`gallery-filter ${active === cat ? 'active' : ''}`}
            onClick={() => handleSelect(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="gallery-grid">
        {filtered.map((item, i) => (
          <ScrollReveal
            as="figure"
            key={item.id}
            delay={(i % 6) * 70}
            className="gallery-item"
            onClick={() => setLightbox(item)}
          >
            <img src={bgPhoto(item.image)} alt={`${item.title} — ${item.category}`} loading="lazy" />
            <figcaption>
              <span className="gallery-item-cat">{item.category}</span>
              <span className="gallery-item-title">{item.title}</span>
            </figcaption>
          </ScrollReveal>
        ))}
      </div>

      {lightbox && (
        <div className="lightbox" role="dialog" aria-modal="true" onClick={() => setLightbox(null)}>
          <button className="lightbox-close" aria-label="Close">×</button>
          <img src={bgPhoto(lightbox.image, 1200, 1400)} alt={lightbox.title} onClick={(e) => e.stopPropagation()} />
          <p>{lightbox.title} — {lightbox.category}</p>
        </div>
      )}
    </div>
  )
}
